<template>
  <div class="reports-dashboard">
    <!-- 📊 EXECUTIVE SUMMARY -->
    <v-row class="mb-6">
      <v-col cols="12">
        <v-card class="executive-summary" elevation="8">
          <v-card-title class="pa-6 bg-gradient-primary text-white">
            <v-icon size="32" class="mr-3">mdi-view-dashboard-variant</v-icon>
            <span class="text-h4">Dashboard Ejecutivo</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. Las cuatro métricas ejecutivas ("Reportes Generados" 2,847,
            "Tiempo Promedio" 2.3s, "Tasa de Éxito" 98.7%, "Usuarios Activos" 156) y sus
            variaciones ("+12.5%", "-0.8s", "+0.3%", "+23") eran un array literal declarado en
            este mismo archivo, igual que el chip "Performance: Excelente" del encabezado, que
            estaba escrito directamente en la plantilla y no podía ser desmentido por ninguna
            medición. Este componente no importa ningún cliente HTTP y no existe productor: bajo
            reportes el backend sólo monta /api/reports/organizational (src/app.js:568). Una
            tarjeta sin productor se retira, no se rellena.
          -->
          <v-card-text class="pa-6" data-testid="reports-executive-metrics-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Estas cifras no tienen un productor canónico y fueron retiradas en P13-V5A-R5.
              Los indicadores con respaldo real se publican en el reporte organizacional
              (/reports/organizational).
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!--
      P13-V7B · RETIRED: the four quick-action cards. "Generar Reporte Inmediato" ("en menos de 60
      segundos") could only raise a "no disponible" error in the parent; "Análisis Predictivo" ("IA
      para predicciones") jumped to a tab whose every card is a retirement notice; "Alertas
      Inteligentes" and "Distribución Masiva" had empty branches and did nothing at all. No report
      generator, predictive model, alert configurator or distribution surface exists in the backend.
    -->
    <div class="mb-6" data-testid="reports-quick-actions-retired">
      <v-alert type="info" variant="tonal" density="compact">
        La generación inmediata, el análisis predictivo, las alertas y la distribución de reportes no
        están disponibles: no existe un productor para ninguna de ellas.
      </v-alert>
    </div>

    <!-- 📈 REAL-TIME ANALYTICS -->
    <v-row class="mb-6">
      <v-col cols="12" lg="8">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="primary" class="mr-3">mdi-chart-line-variant</v-icon>
            <span class="text-h5">Generación de Reportes</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. La serie del gráfico era un objeto literal con tres arrays
            fijos ("7d" [12,19,15,25,22,30,28], "30d" y "90d") y etiquetas generadas en el
            cliente; el selector 7D/30D/90D sólo elegía cuál de las tres constantes dibujar, de
            modo que la "tendencia de generación de reportes" era la misma curva en cada carga y
            para cada usuario. No hay productor: no existe ningún endpoint de series de reportes
            (bajo reportes el backend sólo monta /api/reports/organizational, src/app.js:568) y
            este componente no emite ninguna petición. Se retira el gráfico junto con el
            selector de período, que sin serie no filtra nada.
          -->
          <v-card-text class="pa-6" data-testid="reports-generation-chart-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Esta serie no tiene un productor canónico y fue retirada en P13-V5A-R5. La
              capacidad de reportar la generación de reportes en el tiempo no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" lg="4">
        <v-card elevation="4" class="h-100">
          <v-card-title class="pa-6">
            <v-icon color="info" class="mr-3">mdi-account-group</v-icon>
            <span class="text-h5">Actividad por Rol</span>
          </v-card-title>
          
          <!--
            P13-V5A-R5 · RETIRED. El desglose por rol (Super Admin 47, Group Manager 32, Field
            Supervisor 28, Administrator 19, con sus barras al 85/65/55/40 %) era un array
            literal. Presentaba como medida de actividad por rol unas cifras que nadie contaba:
            no hay endpoint que agregue uso de reportes por rol, y este componente no realiza
            ninguna llamada. Una tarjeta sin productor se retira, no se rellena.
          -->
          <v-card-text class="pa-6" data-testid="reports-role-activity-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Esta distribución no tiene un productor canónico y fue retirada en P13-V5A-R5. La
              actividad por rol no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- 🎯 RECENT ACTIVITY & ALERTS -->
    <v-row>
      <v-col cols="12" lg="6">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="warning" class="mr-3">mdi-bell-ring</v-icon>
            <span class="text-h5">Alertas del Sistema</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. Las tres "alertas activas" eran un array literal con
            marcas de tiempo calculadas en el montaje (Date.now() menos 15 min, 45 min y 2 h),
            de forma que siempre parecían recién emitidas: afirmaban un incremento del 35 % en
            generación de reportes, una recomendación del sistema sobre consultas de base de
            datos y un mantenimiento programado, ninguno de los cuales fue detectado ni
            programado por nadie. El chip "N activas" contaba la longitud de ese mismo array.
            No existe productor de alertas del sistema para esta pantalla.
          -->
          <v-card-text class="pa-6" data-testid="reports-system-alerts-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Estas alertas no tienen un productor canónico y fueron retiradas en P13-V5A-R5. La
              vigilancia de alertas del sistema no está disponible en esta pantalla.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" lg="6">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="success" class="mr-3">mdi-history</v-icon>
            <span class="text-h5">Actividad Reciente</span>
          </v-card-title>
          
          <!--
            P13-V5A-R5 · RETIRED. La línea de tiempo mostraba cuatro acciones atribuidas a
            personas inventadas (tres nombres propios que no corresponden a ningún usuario del
            sistema, más "Sistema"), con marcas de tiempo relativas al momento de montar el
            componente, de modo que la actividad siempre parecía haber ocurrido hace minutos.
            Era un array literal: no hay auditoría ni feed de actividad detrás, y este
            componente no realiza ninguna llamada. Atribuir una acción a una persona que no la
            hizo es la forma más grave de esta clase de defecto, así que se retira entera.
          -->
          <v-card-text class="pa-6" data-testid="reports-recent-activity-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Esta actividad no tiene un productor canónico y fue retirada en P13-V5A-R5. El
              historial de actividad de reportes no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
// P13-V5A-R5 · RETIRED. Con las tarjetas se retira el estado que sólo existía para llenarlas:
// `executiveMetrics` (los cuatro literales del dashboard ejecutivo), `roleActivity`,
// `systemAlerts` y `recentActivity` (arrays literales), el gráfico (`reportsChart`,
// `chartInstance`, `chartPeriod`, `createReportsChart()`, `generateChartLabels()` y su watch),
// y `formatRelativeTime()`, que sólo daba apariencia de frescura a marcas de tiempo generadas
// en el montaje. Desaparecen con ellos las importaciones que quedaban sin uso: `chart.js/auto`,
// `date-fns`, su locale `es` y los ciclos de vida `onMounted`/`nextTick`/`watch`.
//
// También se elimina el prop `liveData`: el padre le pasaba sus cifras aleatorias (ya retiradas
// en EnterpriseReportsCenter.vue) y este componente nunca lo leía.

// P13-V7B · RETIRED: `quickActions`, `executeQuickAction` and `defineEmits(['generate-report',
// 'view-analytics'])`, together with the four cards they drew (see the template). The component
// emits nothing now, and imports nothing: it is a static statement of which report capabilities do
// not exist.
</script>

<style scoped lang="scss">
.reports-dashboard {
  .executive-summary {
    border-radius: 20px;
    overflow: hidden;
  }
  
  .bg-gradient-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .quick-action-card {
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
    }
    
    &.featured {
      background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
      box-shadow: 0 8px 32px rgba(76, 175, 80, 0.3);
    }
  }
  
  .action-icon {
    width: 80px;
    height: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  
}
</style>
